import React, { useRef, useState } from "react";
import { Upload, X, Image } from "lucide-react";
import { licenseService } from "../../../Services/license.service";

const IMAGE_TYPE_BY_ID = {
  Logo: "Logo",
  HomeScreen: "HomeScreen",
  InternalLogo: "InternalLogo",
  FaveIcon: "FaveIcon",
};

const ALLOWED_IMAGE_TYPES = ["image/png", "image/jpg", "image/jpeg"];

const resolveUploadedImageUrl = (uploaded) => {
  if (!uploaded) return "";
  if (typeof uploaded === "string") return uploaded;

  return (
    uploaded.url ||
    uploaded.link ||
    uploaded.imageUrl ||
    uploaded.imageLink ||
    uploaded.path ||
    uploaded.Url ||
    uploaded.Link ||
    uploaded.ImageUrl ||
    uploaded.ImageLink ||
    uploaded.Path ||
    ""
  );
};

export default function ImageUploadField({ label, description, value, onChange, id }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (file) => {
    if (!file) return;

    const fileName = file.name?.toLowerCase() || "";
    const hasValidExtension = fileName.endsWith(".png") || fileName.endsWith(".jpg") || fileName.endsWith(".jpeg");
    const hasValidMimeType = ALLOWED_IMAGE_TYPES.includes((file.type || "").toLowerCase());

    if (!hasValidExtension && !hasValidMimeType) {
      console.error("Formato inválido. Envie apenas PNG, JPG ou JPEG.");
      return;
    }

    setUploading(true);

    try {
      const imageType = IMAGE_TYPE_BY_ID[id];

      if (!imageType) {
        console.error("ImageUploadField: id inválido para upload", id);
        return;
      }

      const uploaded = await licenseService.uploadLicensedImage(imageType, file);
      const uploadedUrl = resolveUploadedImageUrl(uploaded);

      if (uploadedUrl) {
        onChange(uploadedUrl);
      } else {
        console.error("Não foi possível obter a URL da imagem no retorno do upload", uploaded);
      }
    } catch (err) {
      console.error("Erro no upload da imagem", err);
    } finally {
      setUploading(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) handleFile(file);
  };

  return (
    <div className="d-flex flex-column gap-2">
      <div className="d-flex justify-content-between align-items-center">
        <label className="small fw-semibold text-secondary text-uppercase">{label}</label>
        {value && (
          <button
            onClick={() => onChange("")}
            className="text-secondary btn btn-link p-0"
            style={{ textDecoration: 'none' }}
          >
            <X size={14} />
          </button>
        )}
      </div>
      {description && <p className="small text-secondary">{description}</p>}
      <div
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        onClick={() => !uploading && inputRef.current.click()}
        className="position-relative d-flex align-items-center justify-content-center rounded border bg-light overflow-hidden"
        style={{ minHeight: 90, borderStyle: 'dashed' }}
      >
        {value ? (
          <div className="position-relative w-100" style={{ height: 96 }}>
            <img src={value} alt={label} className="w-100 h-100" style={{ objectFit: 'contain', padding: 8 }} />
            <div className="position-absolute top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center" style={{ background: 'rgba(0,0,0,0.3)', opacity: 0 }}>
              <Upload size={20} className="text-white" />
            </div>
          </div>
        ) : (
          <div className="d-flex flex-column align-items-center justify-content-center py-3 gap-2">
            {uploading ? (
              <div className="spinner-border text-warning" role="status" style={{ width: '1.25rem', height: '1.25rem' }} />
            ) : (
              <>
                <Image size={22} className="text-muted" />
                <span className="small text-secondary">Clique ou arraste a imagem</span>
              </>
            )}
          </div>
        )}
        <input
          ref={inputRef}
          type="file"
          accept=".png,.jpg,.jpeg"
          style={{ display: 'none' }}
          onChange={(e) => handleFile(e.target.files[0])}
        />
      </div>
    </div>
  );
}